import { apiClient } from '../../gateways/api'
import type { FetchAutosuggest } from '../types/FetchAutosuggest'

export { fetchAutosuggest, initialState, createParts, makeAddParts }

const initialState: FetchAutosuggest = {
  data: [],
}

const fetchAutosuggest = async ({
  text,
  entityType,
  isHoofdleiding,
}: {
  text: string
  entityType?: string
  isHoofdleiding?: boolean
}): Promise<FetchAutosuggest['data']> => {
  if (text && text.trim().length > MIN_QUERY_SIZE) {
    let url = '/rest/project/aansluiting/autosuggest'

    if (entityType) url = `/rest/${entityType}/autosuggest`
    if (isHoofdleiding) url = `/rest/project/hoofdleiding/autosuggest`

    const addParts = makeAddParts(createParts)
    const { data } = await apiClient({
      url,
      method: 'POST',
      data: { text: text.trim() },
    })

    return addParts(text, data)
  }

  return []
}

const MIN_QUERY_SIZE = 3

const createParts = (value, q) => {
  const parts: any[] = []
  let text
  const query = (q || '').trim()

  if (value && query) {
    const idx = value.toLowerCase().indexOf(query.toLowerCase())

    if (idx === 0) {
      text = value.slice(0, query.length)
      parts.push({ text, highlight: true })
      text = value.slice(query.length)
      parts.push({ text, highlight: false })
    } else if (idx > 0) {
      text = value.slice(0, idx)
      parts.push({ text, highlight: false })
      text = value.slice(idx, idx + query.length)
      parts.push({ text, highlight: true })
      if (idx < value.length - query.length) {
        text = value.slice(idx + query.length)
        parts.push({ text, highlight: false })
      }
    }
  }

  if (parts.length === 0) parts.push({ text: value, highlight: false })

  return parts
}

const makeAddParts = (createParts) => (text, items) =>
  items.map((as) => ({ ...as, parts: createParts(as.v, text) }))
